export enum TicketEvent {
  CHECKED_IN = 'TL_TICKET_CHECKED_IN',
}

export enum TicketTokenType {
  QR = 'QR',
}

export enum TicketAction {
  CHECK_IN_BY_ID = 'CHECK_IN_BY_ID',
  CHECK_IN_BY_TOKEN = 'CHECK_IN_BY_TOKEN',
  CHECK_IN_BY_BATCH = 'CHECK_IN_BY_BATCH',
}
